module.exports = __webpack_public_path__ + "static/media/footer4.c87a198f.jpeg";